// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CouponSubmitDocumentsRequestModel } from './couponSubmitDocumentsRequestModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CouponDocumentsType {
    'programId': number;
    'body': CouponSubmitDocumentsRequestModel | null;
    'memberNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CouponDocumentsType>> = [
        {
            "name":     "programId",
            "baseName": "programId",
            "type":     "number"
        },
        {
            "name":     "body",
            "baseName": "body",
            "type":     "CouponSubmitDocumentsRequestModel"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CouponDocumentsType.attributeTypeMap;
    }
}
